import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface HudleFriendsTabProps {
  data: Record<string, any>;
}

export const HudleFriendsTab: React.FC<HudleFriendsTabProps> = ({ data }) => {
  const friends = data.friends || [];

  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  const getStatusLabel = (status?: string) => {
    const labels: Record<string, string> = {
      pending: 'Ожидание',
      accepted: 'Принято',
      blocked: 'Заблокировано',
    };
    return labels[status || ''] || status || '—';
  };

  const getStatusVariant = (status?: string): 'success' | 'warning' | 'error' | 'info' | undefined => {
    switch (status) {
      case 'accepted': return 'success';
      case 'pending': return 'warning';
      case 'blocked': return 'error';
      default: return 'info';
    }
  };

  if (friends.length === 0) {
    return <S.EmptyState>Нет данных о друзьях</S.EmptyState>;
  }

  return (
    <div>
      <S.SectionTitle>Друзья ({friends.length})</S.SectionTitle>
      {friends.map((friend: any, index: number) => (
        <S.ListItem key={index}>
          <S.ListItemTitle>{friend.friend_username || `ID: ${friend.friend_id}`}</S.ListItemTitle>
          <S.InfoRow>
            <S.InfoLabel>ID друга</S.InfoLabel>
            <S.InfoValue>{friend.friend_id || '—'}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Статус</S.InfoLabel>
            <S.InfoValue>
              <S.Badge $variant={getStatusVariant(friend.status)}>
                {getStatusLabel(friend.status)}
              </S.Badge>
            </S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Создано</S.InfoLabel>
            <S.InfoValue>{formatDate(friend.created_at)}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Обновлено</S.InfoLabel>
            <S.InfoValue>{formatDate(friend.updated_at)}</S.InfoValue>
          </S.InfoRow>
        </S.ListItem>
      ))}
    </div>
  );
};

